import React from "react";
import Special from "./Special";
import ProductList from "./products/ProductList";
import { About } from "./About";

const Home: React.FC = () => {

  return (
    <div className="">
      <Special />
      <div className="px-5 lg:px-36">
        <ProductList />
      </div>
      <About />
    </div>
  );
};

export default Home;
